import { type Dtos, type SuretyAccountId, SuretyType } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { recentlyUsedSfaaCodesQueryKey } from "../sfaa-code.keys";

export const useFetchRecentlyUsedSfaaCodes = (
	accountId: SuretyAccountId,
	params: { suretyType: SuretyType },
	enabled: boolean = true,
) => {
	const { get } = useRequest();
	const request: Dtos.SfaaCode.RecentlyUsed.Request = {
		suretyType: params.suretyType === SuretyType.contract ? "contract" : "commercial",
	};

	const { data, error, isLoading, isFetching, refetch } = useQuery({
		queryKey: recentlyUsedSfaaCodesQueryKey(accountId, request),
		enabled,
		queryFn: async () => {
			const search = new URLSearchParams();
			search.set("suretyType", request.suretyType);
			return await get<Dtos.SfaaCode.List.Response>(
				`/v2/admin/surety/accounts/${accountId}/sfaa-codes/recently-used?${search.toString()}`,
			);
		},
	});

	return {
		recentlyUsedSfaaCodes: data,
		recentlyUsedSfaaCodesError: error,
		recentlyUsedSfaaCodesIsLoading: isLoading,
		recentlyUsedSfaaCodesIsFetching: isFetching,
		refetchRecentlyUsedSfaaCodes: refetch,
	};
};
